import { __rest } from 'tslib';
import React from 'react';
import { BaseEditor } from './BaseEditor.js';
import { ViewerLayout } from '../components/viewer-layout/index.js';

const WebEditor = (_a) => {
    var { refetch } = _a, props = __rest(_a, ["refetch"]);
    return (React.createElement(ViewerLayout, { refetch: refetch },
        React.createElement(BaseEditor, Object.assign({}, props))));
};

export { WebEditor, WebEditor as default };
